// Dependencias generales
import React from "react";
import { useEffect } from 'react';

import imgNoResultsDark from '../../img/dark-theme/empty-state.svg'

var dashboardCommonJS = require("../../js/dashboardCommon.js")
var generalCommonJS = require("../../js/generalCommon.js")

const InstallationActivityDay = (appsParam) => {

  useEffect(() => {    
    console.log("Listado de actividad diaria cargado correctamente.")        
  },[]);

  function irARegla(idRegla){    
    localStorage.setItem("ruleDirectLink"+localStorage.getItem("installationId"),idRegla)
    appsParam.seleccionarOpcionMenu("opcionMenuRules")    
  }

  const DayActivityList = () => {    

    if(appsParam.objActividadDia.length > 0){

      const listActivity = appsParam.objActividadDia.map((eventoActividad, index) =>        

        <React.Fragment key={"IADA"+index}>
          { eventoActividad.actionValue.includes("·") ?
            [eventoActividad.actionValue.split("·").length === 2 ?            
              <li id={"liEvento-"+appsParam.dia+"-"+index} key={index} searchtext={dashboardCommonJS.obtenerNombreDispositivo(eventoActividad.activityCategory,eventoActividad.deviceName)+" "+dashboardCommonJS.obtenerDatosUsuarioActivadorAccion("nombreLargo",eventoActividad.actionValue)} className="horizontal gap-04 center" onClick={() => irARegla(eventoActividad.actionValue.split("·")[1])}>
                <figure className={"avatar size-m "+dashboardCommonJS.obtenerColorIcono(eventoActividad.activityCategory, eventoActividad.actionStatusId)}><span className="material-icon">{dashboardCommonJS.obtenerIconoGrupoDispositivos(dashboardCommonJS.obtenerTipoDispositivo(eventoActividad.deviceId, eventoActividad.activityCategory))}</span></figure>
                <dl className="vertical fill">
                  <dt className="size-l">{dashboardCommonJS.obtenerNombreDispositivo(eventoActividad.activityCategory,eventoActividad.deviceName)}</dt>                                            
                    <dd className="size-s clarification vertical-center" style={{marginTop: "-7px"}}><span className="vertical-center">{dashboardCommonJS.formatearAFechaHoraCorta(eventoActividad.DATETIME, "UTC").split("-")[0]} - {dashboardCommonJS.obtenerLiteralEstadoAccion(eventoActividad.actionStatusId)} {eventoActividad.actionValue.split("·")[0]} {dashboardCommonJS.obtenerUnidadAccion(eventoActividad)} | </span><button className="link inline-link"><span className="vertical-center">Regla </span> <span className="size-s material-icon flip-right vertical-center">expand_circle_down</span></button></dd>                                  
                </dl> 
              </li>                
            :
            
              <li id={"liEvento-"+appsParam.dia+"-"+index} key={index} searchtext={dashboardCommonJS.obtenerNombreDispositivo(eventoActividad.activityCategory,eventoActividad.deviceName)+" "+dashboardCommonJS.obtenerDatosUsuarioActivadorAccion("nombreLargo",eventoActividad.actionValue)} className="horizontal gap-04 center">          
                <figure className={"avatar size-m "+dashboardCommonJS.obtenerColorIcono(eventoActividad.activityCategory, eventoActividad.actionStatusId)}><span className="material-icon">{dashboardCommonJS.obtenerIconoGrupoDispositivos(dashboardCommonJS.obtenerTipoDispositivo(eventoActividad.deviceId, eventoActividad.activityCategory))}</span></figure>
                <dl className="vertical fill">
                  <dt className="size-l">{dashboardCommonJS.obtenerNombreDispositivo(eventoActividad.activityCategory,eventoActividad.deviceName)}</dt>                                            
                    <dd className="size-s clarification vertical-center" style={{marginTop: "-7px"}}>                      
                      { generalCommonJS.obtenerEmailUsuario() === dashboardCommonJS.obtenerDatosUsuarioActivadorAccion("email",eventoActividad.actionValue) ?
                        <span className="vertical-center">{dashboardCommonJS.formatearAFechaHoraCorta(eventoActividad.DATETIME, "UTC").split("-")[0]} - {dashboardCommonJS.obtenerLiteralEstadoAccion(eventoActividad.actionStatusId)} {eventoActividad.actionValue.split("·")[0]} {dashboardCommonJS.obtenerUnidadAccion(eventoActividad)}</span>                                            
                      :
                        <span className="vertical-center">{dashboardCommonJS.formatearAFechaHoraCorta(eventoActividad.DATETIME, "UTC").split("-")[0]} - {dashboardCommonJS.obtenerLiteralEstadoAccion(eventoActividad.actionStatusId)} {eventoActividad.actionValue.split("·")[0]} {dashboardCommonJS.obtenerUnidadAccion(eventoActividad)} por {dashboardCommonJS.obtenerDatosUsuarioActivadorAccion("nombreLargo",eventoActividad.actionValue)}</span>                                                                    
                      } 
                    </dd>                    
                </dl>                 
              </li>                
            ]

          :
            <li id={"liEvento-"+appsParam.dia+"-"+index} key={index} searchtext={dashboardCommonJS.obtenerNombreDispositivo(eventoActividad.activityCategory,eventoActividad.deviceName)+" "+dashboardCommonJS.obtenerDatosUsuarioActivadorAccion("nombreLargo",eventoActividad.actionValue)} className="horizontal gap-04 center">
              <figure className={"avatar size-m "+dashboardCommonJS.obtenerColorIcono(eventoActividad.activityCategory, eventoActividad.actionStatusId)}><span className="material-icon">{dashboardCommonJS.obtenerIconoGrupoDispositivos(dashboardCommonJS.obtenerTipoDispositivo(eventoActividad.deviceId, eventoActividad.activityCategory))}</span></figure>
              <dl className="vertical fill">
                <dt className="size-l">{dashboardCommonJS.obtenerNombreDispositivo(eventoActividad.activityCategory,eventoActividad.deviceName)}</dt>                            
                  <dd className="size-s clarification">{dashboardCommonJS.formatearAFechaHoraCorta(eventoActividad.DATETIME, "UTC").split("-")[0]} - {dashboardCommonJS.obtenerLiteralEstadoAccion(eventoActividad.actionStatusId)} {eventoActividad.actionValue.split("·")[0]} {dashboardCommonJS.obtenerUnidadAccion(eventoActividad)}</dd>                    
              </dl> 
            </li>                            
          }
        </React.Fragment>

      );   

      return (
        <ul className="accordion-content vertical gap-04">
          {listActivity}
        </ul>
      )

    }
    else{      
      return (
        <div className="message medium empty">
          <picture>
            <source srcSet={imgNoResultsDark} media="(prefers-color-scheme: dark)"/>
            <img src={imgNoResultsDark} alt=""/>
          </picture>
          <h1 className="">Sin actividad</h1>
        </div>
      );
    }
  }

  return (          
    <DayActivityList/>
  )
}

export default InstallationActivityDay